import { Stack } from '@mui/material';
import { HeaderTitle } from '../HeaderTitle';
import { SimulationGroup } from '@thive/fddm-types';
import { CreatedCompletedDatesRow } from '@/modules/simulation/components/CreatedCompletedDatesRow';
import { CompletedDuration } from '@/modules/simulation/components/CompletedDuration';
import { SimulationServiceFactory } from '@/modules/simulation/service/SimulationServiceFactory';
import { useCallback, useMemo } from 'react';
import { BottomButtons } from '@/modules/simulation/components/BottomButtons';

type Props = {
  simulationGroup: SimulationGroup;
  isHover: boolean;
  onClick: () => void;
  onAbort: (simulationGroup: SimulationGroup) => void;
};

export const CardContent = ({ simulationGroup, isHover, onClick, onAbort }: Props) => {
  const simSvc = useMemo(
    () => SimulationServiceFactory.getInstance().createSimulationService(),
    [],
  );

  const onAbortConfirm = useCallback(() => {
    onAbort(simulationGroup);
  }, [onAbort, simulationGroup]);

  const onChanged = useCallback(
    (name: string) => {
      // eslint-disable-next-line react-hooks/immutability
      simulationGroup.name = name;
      simSvc.renameSimulationGroup(simulationGroup.id, name);
    },
    [simulationGroup, simSvc],
  );

  const editable = true;

  return (
    <Stack sx={{ gap: 1 }}>
      <HeaderTitle value={simulationGroup.name} editable={editable} onChange={onChanged} />
      <Stack sx={{ flexDirection: 'row', gap: 1, width: '100%' }}>
        <Stack sx={{ gap: 1, width: '100%' }} onClick={onClick}>
          <> {/* <VersionVehicleRow simulationGroup={simulationGroup} /> */} </>
          <CreatedCompletedDatesRow simulation={simulationGroup} />
          <CompletedDuration simulation={simulationGroup} />
        </Stack>
        {isHover && (
          <BottomButtons simulationGroup={simulationGroup} onAbortConfirm={onAbortConfirm} />
        )}
      </Stack>
    </Stack>
  );
};
